import Env from '../../base/env';
import Channels from '../../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import easesCustom from '../../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.cache = this.DOM.view.querySelector('.fxCacheSEO')
    this.DOM.svg = this.DOM.view.querySelector('svg')
    this.DOM.svgGroups = this.DOM.view.querySelectorAll('g')
    this.DOM.visuals = this.DOM.view.querySelectorAll('.fxVisual')
    this.DOM.masks = this.DOM.view.querySelectorAll('.fxMask')
    //! Fns
    this.funcLaunch = this._fx.bind(this)
    this.prepareFx()
    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  _fx()
  {
    this.reveal()
  }

  prepareFx()
  {
    for(let i = 0; i < this.DOM.svgGroups.length; i++) {
      let group = this.DOM.svgGroups[i]
      let modulo = i % 2
      const posY = (modulo == 0)?160:-160;
      gsap.set(group.querySelectorAll('path'), { y: posY })
    }
  }


  reveal()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          duration:.1,
          ease:easesCustom.cubic
        }
      ),
    ])
    for(let i = 0; i < this.DOM.svgGroups.length; i++) {
      let group = this.DOM.svgGroups[i]
      let modulo = i % 2
      const staggerTiming = (modulo == 0)?.07:-.07;
      let timing = (i == 0)?'+=.1':'<';
      this.animation.add([
        gsap.to(
          group.querySelectorAll('path'),
          {
            y:0,
            ease:easesCustom.quart,
            duration:1,
            stagger:staggerTiming
          }
        ),
      ],timing)
    }

    // Mask animation
    for(const [i,visual] of this.DOM.visuals.entries()) {
      const modulo = i % 2
      const posXTo = (i == 1)?'100%':'-100%';
      let settingsTween = {}
      const offsetStart = (Env.mobileCSS)?'top 90%':'top 80%';
      if(i > 0) {
        settingsTween = {
          scrollTrigger:{
            trigger:visual,
            start:offsetStart
          }
        }
      }
      const animationVisual = gsap.timeline(settingsTween)
      const mask = this.DOM.masks[i]
      animationVisual.add([
        gsap.fromTo(
          mask,
          {
            y:0
          },
          {
            y:posXTo,
            ease:easesCustom.quart,
            duration:.8
          }
        ),
        gsap.fromTo(
          visual,
          {
            scale:1.1
          },
          {
            scale:1,
            ease:easesCustom.quart,
            duration:1,
            delay:.05
          }
        )
      ],'+=.3')
    }

  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
  }
}
